import { Injectable } from '@angular/core';
import * as Cookies from 'es-cookie';
import { CookieAttributes } from 'es-cookie/src/CookieAttributes';

@Injectable({
  providedIn: 'root'
})
export class SxCookieService {

  constructor() { }

  setCookie(key: string, value: any, options: CookieAttributes = {}) {
    Cookies.set(key, value, options);
  }

  getCookie(key: string) {
    return Cookies.get(key);
  }

  clearCookie(key: string, options: CookieAttributes = {}) {
    Cookies.remove(key, options);
  }
}